import React, {useState, useEffect, useRef, useContext, Fragment} from "react";
import {useHistory} from 'react-router-dom'
import Card from "../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../context/LoaderContext";
import {TranslateContext} from "../../context/TranslateContext";
import LabelErroreCampo from "../../components/LabelErroreCampo";
import Translate from "../../components/Translate";
import NsDatePicker from "../../components/NsDatePicker";
import {convertiTimestampInDataPerDb, handleMoneyChange} from "../../utility/common";
import NsFormikScrollToError from "../../components/NsFormikScrollToError";
import NSSelectAutocomplete from "../../components/NSSelectAutocomplete";
import NsBtnBack from "../../components/buttons/NsBtnBack";
import {getModalitaPagamentoApi} from "../../services/QuoteServices";
import {getContiApi, getCausaliMovimentoApi} from "../../services/MovimentiServices";
import {
    aggiungiQuotaCertificatoApi,
    getCertificatoByIdApi,
    getInfoPagamentoApi
} from "../../services/CertificatiServices";

export default function AddQuotaCertificato({socio, idCertificato}) {

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [optionsModalita, setOptionsModalita] = useState([]);
    const [optionsConti, setOptionsConti] = useState([]);
    const [causali, setCausali] = useState([]);
    const [tipiVersamento, setTipiVersamento] = useState([]);
    const [certificato, setCertificato] = useState();

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getModalitaPagamento() {
        startChiamata();

        const response = await getModalitaPagamentoApi();
        endChiamata();
        setOptionsModalita(response.data.data);
    }

    async function getConti() {
        startChiamata();

        const response = await getContiApi();
        endChiamata();
        setOptionsConti(response.data.data);
    }

    async function getCertificato() {
        startChiamata();

        const response = await getCertificatoByIdApi(idCertificato);
        endChiamata();

        let data = response.data.data;
        if (data) {
            setCertificato(data);
            if (data && formikRef.current) {
                formikRef.current.setFieldValue("targa", data.targa);
                formikRef.current.setFieldValue("tipo_certificato", data.tipo_certificato);
            }
        }
    }

    async function getInfoPagamento() {
        startChiamata();

        const response = await getInfoPagamentoApi(idCertificato);
        endChiamata();

        let data = response.data.data;
        if (data && data.pagamentiRichiesti && data.pagamentiRichiesti.length > 0) {
            let importo = 0;
            let tipiVersamento = [];
            data.pagamentiRichiesti.forEach(p => {
                importo += parseFloat(p.costo);
                tipiVersamento.push(p.id_tipo_versamento);
            });

            setTipiVersamento(tipiVersamento);
            if (tipiVersamento && formikRef.current) {
                formikRef.current.setFieldValue("id_tipo_versamento", tipiVersamento.join(';'));
            }
        }
    }

    async function getCusali() {
        startChiamata();

        const response = await getCausaliMovimentoApi({
            id_categoria_causale: "ISCRIZ"
        });
        setCausali(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        getCertificato();
        getModalitaPagamento();
        getInfoPagamento();
        getCusali();
        getConti();

        if (tipiVersamento && formikRef.current) {
            formikRef.current.setFieldValue("id_tipo_versamento", tipiVersamento.join(';'));
        }
        if (certificato && formikRef.current) {
            formikRef.current.setFieldValue("targa", certificato.targa);
            formikRef.current.setFieldValue("tipo_certificato", certificato.tipo_certificato);
        }
    }, [idCertificato, socio]);

    const SignupSchema = Yup.object().shape({
        data_pagamento: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        importo: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        id_modalita: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        id_causale_movimento: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
    });

    async function aggiungiQuotaCertificato(newQuota) {
        startChiamata();

        const response = await aggiungiQuotaCertificatoApi(idCertificato, newQuota);
        endChiamata();

        if (response.data.result === 0) {
            history.push("/info-certificato/" + idCertificato);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    return (
        <Card
            icon={'fas fa-credit-card'}
            title={'Inserisci Quota Certificato'}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button type="button" id="salva" name="salva"
                            className="btn btn-card"
                            onClick={() => {
                                if (formikRef.current) {
                                    formikRef.current.handleSubmit()
                                }
                            }}>
                        <i className="fas fa-save"/> Salva
                    </button>
                </Fragment>
            }>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Formik
                initialValues={{
                    id_quota: '',
                    tipo_certificato: certificato ? certificato.tipo_certificato : '',
                    id_certificato: idCertificato,
                    data_pagamento: new Date(),
                    importo: '',
                    id_modalita: '',
                    id_tipo_versamento: tipiVersamento ? tipiVersamento.join(';') : '',
                    note: '',
                    lrid: '',
                    canc: '0',
                    id_causale_movimento: '',
                    targa: certificato ? certificato.targa : '',
                    id_conto: ''
                }}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={values => {
                    let newQuota = values;
                    newQuota['data_pagamento'] = convertiTimestampInDataPerDb(newQuota['data_pagamento'])

                    aggiungiQuotaCertificato(newQuota);
                }}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="row g-3">
                        <div className="col-md-6">
                            <label htmlFor="tipo_certificato"
                                   className="form-label"><Translate>Certificato</Translate>:</label>
                            <Field name={"tipo_certificato"} className={"form-control"}
                                   readOnly={true}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="targa"
                                   className="form-label"><Translate>Targa</Translate>:</label>
                            <Field name={"targa"} className={"form-control"} readOnly={true}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="data_pagamento" className="form-label"><Translate>Data
                                pagamento*</Translate>:</label>
                            <NsDatePicker
                                nome={"data_pagamento"}
                                dataSelezionata={values["data_pagamento"]}
                                maxDate={new Date()}
                                setSelectedDate={(date, event) => {
                                    formikRef.current.setFieldValue("data_pagamento", date)
                                }}
                            />
                            <LabelErroreCampo errors={errors} touched={touched}
                                              name={"data_pagamento"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="importo" className="form-label">Importo*:</label>
                            <Field
                                name="importo"
                                className="form-control rfi-number-no-arrows"
                                type={"number"}
                                onWheel={(e) => e.target.blur()} // Prevent default scrolling behavior
                                step="0.01"
                                onKeyDown={(e) => {
                                    handleMoneyChange(e)
                                }}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"importo"}
                                              submitCount={submitCount}/>
                        </div>

                        <div className="col-md-6">
                            <label htmlFor="id_modalita" className="form-label">Modalità di
                                pagamento*:</label>
                            <Field as="select" name="id_modalita" className={'form-select'}>
                                <option value={""}>Selezionare una modalità</option>
                                {
                                    optionsModalita.map((op, index) => {
                                        return <option key={index}
                                                       value={op.id_modalita}>{op.descrizione}</option>
                                    })
                                }
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_modalita"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="id_causale_movimento" className="form-label">Causale
                                pagamento*:</label>
                            <NSSelectAutocomplete
                                name={"id_causale_movimento"}
                                formikRef={formikRef}
                                options={causali ? causali.map(cau => {
                                    return {
                                        label: cau.descrizione + ' - [' + cau.id_causale_movimento + ']',
                                        value: cau.id_causale_movimento,
                                    };
                                }) : []}
                                startVal={values["id_causale_movimento"]}
                            />
                            <LabelErroreCampo errors={errors} touched={touched}
                                              name={"id_causale_movimento"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="id_conto" className="form-label">Conto:</label>
                            <Field as="select" name="id_conto" className={'form-select'}>
                                <option value={""}>Selezionare un conto</option>
                                {
                                    optionsConti.map((op, index) => {
                                        return <option key={index}
                                                       value={op.id_conto}>{op.descrizione}</option>
                                    })
                                }
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_conto"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="note" className="form-label">Note sul pagamento:</label>
                            <Field
                                as="textarea"
                                name="note"
                                className={'form-select'}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"note"}
                                              submitCount={submitCount}/>
                        </div>
                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}